import { isAxiosError } from "axios";
import axiosInstance from "../../utility/axiosInstance";

// types and state
import { setLoading, stopLoading } from "../../store/slices/loading";
import {
  ApiResponse,
  Candidate,
  CandidateCreate,
  CandidateCreation,
  GetAllCandidatesQuery,
  GetAllCandidatesResponse,
  GetCandidateResponse,
  GetInterviewResponse,
  InterviewCreate,
  PaginatedData,
} from "../../store/types/candidate";
import { toast } from "sonner";
import { setMessage } from "../../store/slices/message";
import { deleteCandidate } from "../../store/slices/candidate";
import { AppDispatch } from "../../store";

// const API_URL = "https://hr-pas-backend.onrender.com/api/v1";

export const candidatesApi = {
  getAll: async (params?: Record<string, any>) => {
    const response = await axiosInstance.get<
      ApiResponse<PaginatedData<Candidate>>
    >("/candidates", { params });
    return response.data;
  },

  getById: async (id: string) => {
    const response = await axiosInstance.get<ApiResponse<Candidate>>(
      `/candidates/${id}`,
    );
    return response.data;
  },
};

type IGetCandidates = (dispatch: any, id: string | undefined) => Promise<void>;

export const getCandidatess: IGetCandidates = async (
  dispatch: any,
  id: string | undefined,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get(`/job/${id}/candidates`);

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
    }
  }
  dispatch(setLoading());
};

export const getCandidatesByJobId = async (
  id: string | undefined,
  recommendationStatus: string = "all",
) => {
  try {
    const response = await axiosInstance.get(
      `/job/${id}/candidate?recommendationStatus=${recommendationStatus}`,
    );
    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      // Handle error
    }
  }
};
// export const getCandidatesByJobId = async (id: string | undefined) => {
//   try {
//     const response = await axiosInstance.get(`/job/${id}/candidates`);
//     return response.data;
//   } catch (error) {
//     if (isAxiosError(error)) {
//     }
//   }
// };

// Get
export const getCandidates = async (
  query?: GetAllCandidatesQuery,
): Promise<GetAllCandidatesResponse> => {
  const params = new URLSearchParams();
  if (query?.limit) params.append("limit", query.limit);
  // if (query?.category) params.append("category", query.category);

  const response = await axiosInstance.get(
    `/job/candidates?${params.toString()}`,
  );
  return response.data;
};

export const getCandidateById = async (
  id: string,
): Promise<GetCandidateResponse> => {
  const response = await axiosInstance.get(`/job/${id}/candidates`);
  return response.data;
};

export const getInterviewEvaluationById = async (
  interviewId: string,
  id: string,
): Promise<GetInterviewResponse> => {
  const response = await axiosInstance.get(
    `/interview/evaluation?interviewId=${interviewId}&candidateId=${id}`,
  );
  return response.data;
};

// Update Candidate
export const updateCandidat = async (
  dispatch: any,
  candidateId: string,
  candidateData: CandidateCreate | FormData,
) => {
  try {
    // Dispatch loading state if you have it
    // dispatch(setLoading(true));
    console.log("This is candidate data");
    console.log(candidateData);
    const response = await axiosInstance.put(
      `/candidates/${candidateId}`,
      candidateData,
    );

    // dispatch(setMessage({ message: "Candidate updated successfully", type: "success" }));

    return response.data;
  } catch (error) {
    // Handle error
    // dispatch(setMessage({ message: "Failed to update candidate", type: "error" }));
    throw error;
  } finally {
    // dispatch(setLoading(false));
  }
};

// Update interview
export const updateCandidate = async (
  dispatch: any,
  interviewId: string,
  candidateData: InterviewCreate,
) => {
  try {
    console.log(candidateData);
    const response = await axiosInstance.post(
      `/interviews/${interviewId}/reschedule`,
      candidateData,
    );

    // Toast message is handled in the calling function
    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      // Extract the specific error message from the nested error object
      const errorMessage =
        error?.response?.data?.error?.message || // Specific error message
        error?.response?.data?.message || // General message
        "Failed to reschedule interview";

      toast.error(errorMessage);
    }
    throw error;
  }
};

// Create Candidate
type CandidateType = (
  dispatch: any,
  formData: CandidateCreate | FormData,
) => Promise<any>;
export const candidates: CandidateType = async (dispatch, formData) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/candidates", formData);
    console.log(response);

    if (response.data.message) {
      toast.success(response.data.message);
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      // toast.error(error.response?.data.message);
      // dispatch(toast.error(error?.response?.data?.message));
    } else {
    }
    throw error;
  } finally {
    dispatch(stopLoading());
  }
};

// Create Interviews
type InterviewType = (
  dispatch: any,
  formData: InterviewCreate,
) => Promise<void>;
export const candidate: InterviewType = async (dispatch, formData) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      "/interviews/create-from-candidates",
      // "/admin/register-candidate",
      formData,
    );
    console.log(response);

    if (response.data.message) {
      toast.success(response.data.message as unknown as string);
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      // Extract the specific error message from the nested error object
      const errorMessage =
        error?.response?.data?.error?.message || // Specific error message
        error?.response?.data?.message || // General message
        "Failed to create interview";

      toast.error(errorMessage);
    }
    throw error;
  } finally {
    dispatch(stopLoading());
  }
};

export const candidateBulk = async (dispatch: any, formData: FormData) => {
  // Don't dispatch loading here - we're handling UI feedback via toasts
  // dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      "/interviews/bulk-upload-csv",
      formData,
    );

    // Check if response indicates an error
    if (response.data?.status === "error") {
      // Create an error object that matches axios error structure
      const error = new Error(
        response.data?.error?.message ||
          response.data?.message ||
          "An error occurred",
      ) as any;
      error.response = {
        data: response.data,
        status: 400,
      };
      throw error;
    }

    if (response.data?.message === "Candidates already exist!") {
      const error = new Error(response.data?.message) as any;
      error.response = {
        data: response.data,
        status: 400,
      };
      throw error;
    } else {
      dispatch(
        setMessage({
          type: "success",
          message: "Bulk Candidates Created Successfully",
          // message: response?.data?.message,
          title: "Candidate Created",
        }),
      );
      // Don't show toast here - let the calling function handle it with summary
      // toast.success("Bulk Candidates created successfully");
      return response.data;
    }
  } catch (error) {
    // Re-throw the error so the calling function can handle it
    // The error will be caught and displayed as a toast (not as uncaught runtime error)
    throw error;
  } finally {
    // dispatch(stopLoading());
  }
};

// Delete Candidate
export const delete_candidate = async (
  dispatch: AppDispatch,
  id: string,
  navigate: Function,
): Promise<void> => {
  try {
    const handleSuccess = async () => {
      navigate("/candidates");
      // Small delay to ensure navigation happens before reload
      setTimeout(() => {
        window.location.reload();
      }, 100);
    };
    const response = await axiosInstance.delete(`/candidates/${id}`);

    const { data } = response.data;
    dispatch(deleteCandidate(data));
    toast.success(response.data?.message);
    dispatch(
      setMessage({
        // message: "Candidate Deleted Successfully",
        message: response.data?.message,
        type: "success",
        title: "Successful",
      }),
    );
    handleSuccess();
    navigate(`/candidates`);
  } catch (error: any) {
    if (isAxiosError(error)) {
      toast.error(error?.response?.data?.message);
      dispatch(
        setMessage({
          message: error?.response?.data?.message,
          type: "error",
          title: "Failed",
        }),
      );
    }
  }
};
